angular.module('homebot.directives')

  .directive('principalPaymentsSection', ['Dictionary', 'UtilService', 'PRINCIPAL_PAYMENT_OPTIONS', function(Dictionary, utils, PRINCIPAL_PAYMENT_OPTIONS){
    return {
      restrict: 'A',
      controllerAs: 'pmtCtrl',
      bindToController: {
        agent: '=',
        homeId: '@',
        initialPayment: '@',
        loans: '=',
        userId: '@',
      },
      scope: {},
      templateUrl: '/homes/templates/section-principal-payments.html',

      controller: function(){
        var dictionary = new Dictionary();
        var ctrl = this;
        var loans = [];

        function getCorrectLoan(){
          return [dictionary.highestRateLoan({loans: ctrl.loans})];
        };

        ctrl.lookup = function(prop,args,home){
          if(!loans || !loans.length) return '';

          home = home || {loans: loans};
          return dictionary[prop](home, args);
        };

        ctrl.update = function(){
          loans = getCorrectLoan();

          if(!ctrl.payment) {
            var payment = ctrl.lookup('initialDIYPayment');
            ctrl.payment = PRINCIPAL_PAYMENT_OPTIONS[0];

            _.find(PRINCIPAL_PAYMENT_OPTIONS, function (option) {
              if (option > payment)
                return true;
              ctrl.payment = option;
            })
          }
        };

        ctrl.hideTip = function(){
          ctrl.tipOpen = false;
        };

        ctrl.showTip = function(){
          ctrl.tipOpen = true;
        };

        ctrl.toggleTip = function(){
          ctrl.tipOpen = !ctrl.tipOpen;
        };

        ctrl.isTipOpen = function(){
          return ctrl.tipOpen;
        };
      },

      link: function($scope, el, attrs, ctrl){
        $scope.$watchCollection('pmtCtrl.loans', ctrl.update);
      }
    }
  }]);
